/*
# -----------------------------------------------------------------------------
# Component: accountsFilter.js
# Author: antonio.ramirez@pst.sg
# Created Date: 02/April/2019
# Comments: Responsible for all search filter functionality for Manage Accounts
# -----------------------------------------------------------------------------
*/

export const acctTrans = {
  A: 'Adjustment Debit Note',
  B: 'Adjustment Credit Note',
  Y: 'Receipt',
  Z: 'Payment'
}

export const unwTrans = {
  M: 'Direct Business Debit Note',
  N: 'Coinsurance Outward Debit Note',
  O: 'Reinsurance Inward Debit Note',
  P: 'Reinsurance Outward Debit Note',
  Q: 'Miscellaneous Debit Note',
  R: 'Direct Business Credit Note',
  S: 'Coinsurance Outward Credit Note',
  T: 'Reinsurance Inward Credit Note',
  U: 'Reinsurance Outward Credit Note',
  V: 'Miscellaneous Credit Note'
}

export const clmTrans = {
  W: 'Claims Debit Note',
  X: 'Claims Credit Note',
  Y: 'Receipt',
  Z: 'Payment'
}

export const allTrans = {
  A: 'Adjustment Debit Note',
  B: 'Adjustment Credit Note',
  M: 'Direct Business Debit Note',
  N: 'Coinsurance Outward Debit Note',
  O: 'Reinsurance Inward Debit Note',
  P: 'Reinsurance Outward Debit Note',
  Q: 'Miscellaneous Debit Note',
  R: 'Direct Business Credit Note',
  S: 'Coinsurance Outward Credit Note',
  T: 'Reinsurance Inward Credit Note',
  U: 'Reinsurance Outward Credit Note',
  V: 'Miscellaneous Credit Note',
  W: 'Claims Debit Note',
  X: 'Claims Credit Note',
  Y: 'Receipt',
  Z: 'Payment'
}

/*
export const accAction = {
  Review: 'Review',
  Instalments: 'Instalments',
  Matched: 'Matched',
  Refund: 'Refund',
  Commission: 'Commission',
  Query: 'Query'
}
*/

export const accAction = {
  Review: 'Review',
  Matched: 'Matched',
  Query: 'Query'
}

export const glAction = {
  Posted: 'Posted',
  NotPosted: 'Not Posted',
  Both: 'Both'
}

export const commAction = {
  Paid: 'Paid',
  NotPaid: 'Not Paid',
  Both: 'Both'
}

export const accountsFilters = {
  data() {
    return {
      accountsTransForm: {
        transactions: 'Accounts',
        actions: null,
        includeBalance: null,
        branch: null,
        accountNo: null,
        documentNo: null,
        transactionType: null,
        fund: null,
        transactionDate: null,
        currency: null,
        accountNoSuffix: null,
        policyNo: null,
        claimNo: null,
        dueDate: null,
        netAmount: null,
        osBalance: null,
        bankNo: null,
        payersChequeNo: null,
        lastMatchedDate: null,
        gstRate: null,
        accountingYear: null,
        accountingMonth: null,
        addressedTo: null,
        batchNo: null,
        glInterface: null,
        contraJournalNo: null,
        commissionType: null,
        billingAccountNo: null,
        glAccountNo: null,
        glJournalNo: null,
        contraDocumentNo: null,
        commissionNo: null,
        overridingAccountNo: null,
        actionName: null,
        acctPageNo: null,
        acctPageSize: null,
        applyFilters: '',
        includeVoidTransactions: false,
        seqNo: null,
        matchBatchProcess: false,
        matchCreatedProgId: null,
        bankTranDate: null,
        glTranFound: false,
        glTranBchNo: null,
        delAcct: true
      },
      accountsTransFormLabel: {
        transactions: 'Transactions',
        actions: 'Actions',
        includeBalance: 'Include 0.00 balance',
        branch: 'Branch',
        accountNo: 'Account No.',
        documentNo: 'Document No.',
        transactionType: 'Transaction Type',
        fund: 'Fund',
        transactionDate: 'Transaction Date',
        currency: 'Currency',
        accountNoSuffix: 'Account No. Suffix',
        policyNo: 'Policy No.',
        claimNo: 'Claim No.',
        dueDate: 'Due Date',
        netAmount: 'Net Amount',
        osBalance: 'OS Balance',
        bankNo: 'Bank No.',
        payersChequeNo: "Payer's Cheque No.",
        lastMatchedDate: 'Last Matched Date',
        gstRate: 'GST Rate',
        accountingYear: 'Accounting Year',
        accountingMonth: 'Accounting Month',
        addressedTo: 'Addressed To',
        batchNo: 'Batch No.',
        glInterface: 'GL Interface',
        contraJournalNo: 'Contra Journal No.',
        commissionType: 'Commission Type',
        billingAccountNo: 'Billing Account No.',
        glAccountNo: 'GL Account No.',
        glJournalNo: 'GL Journal No.',
        contraDocumentNo: 'Contra Document No.',
        commissionNo: 'Commission No.',
        overridingAccountNo: 'Overriding Account No.',
        includeVoidTransactions: 'Include void transactions',
        warnMsg: '',
        warnMsg2: ''
      },
      transactions: ['All Transactions', 'Accounts', 'Underwriting', 'Claims'],
      actions: [],
      branches: [],
      transactionType: [],
      showAcctNoHelpList: false,
      showDocNoHelpList: false,
      filtersDocNoLabel: {
        documentNo: 'Document No.'
      },
      filtersDocNo: {
        documentNo: undefined,
        extraModuleRequest: undefined,
        tranType: undefined,
        policyNo: undefined,
        accountNo: undefined,
        branch: undefined,
        docPrtd: undefined,
        docPrtILN: undefined,
        fund: undefined,
        acctNoSfx: undefined,
        fromExclGsttran: false
      },
      docNoItems: [],
      totalItemsDocNo: 0,
      docNoHeaders: [
        { text: 'Document No.', align: 'left', value: 'docNo' },
        { text: 'Account No.', align: 'left', value: 'acctNo' },
        { text: 'Branch', align: 'left', value: 'branch' },
        { text: 'Tran Type', align: 'left', value: 'tranType' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      bmDocNoHeaders: [
        { text: 'BmBrn', align: 'left', value: 'branch' },
        { text: 'BmTranType', align: 'left', value: 'tranType' },
        { text: 'BmDocNo.', align: 'left', value: 'docNo' },
        { text: 'BmFund', align: 'left', value: 'fund' },
        { text: 'BmAcctNoSfx', align: 'left', value: 'acctNoSfx' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationDocNo: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationDocNoSuppl: {
        transaction: undefined,
        action: undefined,
        callerPage: undefined
      },
      showFundHelpList: false,
      filtersFundLabel: {
        fund: 'Fund'
      },
      filtersFund: {
        fund: undefined
      },
      fundItems: [],
      totalItemsFund: 0,
      fundHeaders: [
        { text: 'Fund', align: 'left', value: 'fund' },
        { text: 'Fund Description', value: 'fundDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationFund: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showPolicyHelpList: false,
      filtersPolicyLabel: {
        policyNo: 'Policy'
      },
      filtersPolicy: {
        policyNo: undefined
      },
      polItems: [],
      totalItemsPol: 0,
      polHeaders: [
        { text: 'Policy No.', align: 'left', value: 'polNo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      polHeaders2: [
        { text: 'Policy No.', align: 'left', value: 'polNo' },
        { text: 'Renewal Count', align: 'left', value: 'renCnt' },
        { text: 'Endorsement Count', align: 'left', value: 'endtCnt' },
        { text: 'Insured Name', align: 'left', value: 'insdName1' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      polHeaders3: [
        { text: 'Policy No.', align: 'left', value: 'polNo' },
        { text: 'Renewal Count', align: 'left', value: 'renCnt' },
        { text: 'Policy Status', align: 'left', value: 'polStat' },
        { text: 'Commencement Date', align: 'left', value: 'commDate' },
        { text: 'Expiry Date', align: 'left', value: 'expDate' },
        { text: 'Insured Name', align: 'left', value: 'insdName1' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationPolicy: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showClmHelpList: false,
      showAcctSufHelpList: false,
      filtersAcctSufLabel: {
        accountNoSuffix: 'Account No. Suffix'
      },
      filtersAcctSuf: {
        accountNoSuffix: undefined,
        acctNoSfxApplnInt: undefined
      },
      acctSufItems: [],
      totalItemsAcctSuf: 0,
      acctSufHeaders: [
        { text: 'Account No. Suffix', align: 'left', value: 'accountNoSuffix' },
        { text: 'Descption', value: 'desc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationAcctSuf: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showPayersChequeNoHelpList: false,
      filtersPayersChequeNoLabel: {
        payersChequeNo: 'Payer Cheque No.'
      },
      filtersPayersChequeNo: {
        payersChequeNo: undefined
      },
      payersChequeNoItems: [],
      totalItemsPayersChequeNo: 0,
      payersChequeNoHeaders: [
        { text: 'Payer Cheque No.', align: 'left', value: 'payersChequeNo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationPayersChequeNo: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showBankNoHelpList: false,
      showCurrHelpList: false,
      showAddrToHelpList: false,
      filtersAddrToLabel: {
        addressedTo: 'Document Name'
      },
      filtersAddrTo: {
        addressedTo: undefined
      },
      addrToItems: [],
      totalItemsAddrTo: 0,
      addrToHeaders: [
        { text: 'Document Name', align: 'left', value: 'addressedTo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationAddrTo: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showBillAcctNoHelpList: false,
      filtersBillAcctNoLabel: {
        accountNo: 'Account No.'
      },
      filtersBillAcctNo: {
        accountNo: undefined
      },
      billAcctNoItems: [],
      totalItemsBillAcctNo: 0,
      billAcctNoHeaders: [
        { text: 'Account No.', align: 'left', value: 'accountNo' },
        { text: 'Name', value: 'intermediaryName' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationBillAcctNo: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showGlAcctNoHelpList: false,
      filtersGlAcctNoLabel: {
        glacctNo: 'GL Account No.',
        description: 'Description',
        branch: 'Branch',
        fund: 'Fund',
        acctNoSfx: 'Acct No. Sfx'
      },
      filtersGlAcctNo: {
        glacctNo: undefined,
        description: undefined,
        branch: undefined,
        fund: undefined,
        acctNoSfx: undefined,
        yrClosed: undefined
      },
      glAcctNoItems: [],
      totalItemsGlAcctNo: 0,
      glAcctNoHeaders: [
        { text: 'GL Account No.', align: 'left', value: 'glacctNo' },
        { text: 'Descption', value: 'description' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      glAcctNoHeaders2: [
        { text: 'Branch', align: 'left', value: 'branch' },
        { text: 'GL Account No.', align: 'left', value: 'glacctNo' },
        { text: 'Fund', align: 'left', value: 'fund' },
        { text: 'Suffix', align: 'left', value: 'suffix' },
        { text: 'Descption', value: 'description' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationGlAcctNo: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showContraDocNoHelpList: false,
      filtersContraDocNoLabel: {
        contraDocNo: 'Contra Document No.'
      },
      filtersContraDocNo: {
        contraDocNo: undefined
      },
      contraDocNoItems: [],
      totalItemsContraDocNo: 0,
      contraDocNoHeaders: [
        { text: 'Contra Document No.', align: 'left', value: 'contraDocNo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationContraDocNo: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showOvrdAcctNoHelpList: false,
      filtersOvrdAcctNoLabel: {
        ovrdAcctNo: 'Overriding Account No.'
      },
      filtersOvrdAcctNo: {
        ovrdAcctNo: undefined
      },
      ovrdAcctNoItems: [],
      totalItemsOvrdAcctNo: 0,
      ovrdAcctNoHeaders: [
        { text: 'Overriding Account No.', align: 'left', value: 'accountNo' },
        { text: 'Name', value: 'intermediaryName' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationOvrdAcctNo: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showCurrencyHelpList: false,
      filtersCurrencyLabel: {
        currency: 'Currency'
      },
      filtersCurrency: {
        currency: undefined
      },
      currencyItems: [],
      totalItemsCurrency: 0,
      currencyHeaders: [
        { text: 'Currency', align: 'left', value: 'currency' },
        { text: 'Description', value: 'currencyDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationCurrency: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      commissionType: [
        { label: 'Commission',
          value: 'C'
        },
        { label: 'Overriding',
          value: 'O'
        }
      ],
      glInterface: [
        { label: 'Inwards Policy Premium', value: 101 },
        { label: 'Inwards Policy Discount', value: 102 },
        { label: 'Inwards Policy Premium GST', value: 103 },
        { label: 'Inwards Policy Commission 1', value: 104 },
        { label: 'Inwards Policy Commission 1 GST', value: 105 },
        { label: 'Inwards Policy Stamp', value: 106 },
        { label: 'Inwards Policy Fee', value: 107 },
        { label: 'Inwards Policy Tax', value: 108 },
        { label: 'Inwards Policy Risk Stamp', value: 109 },
        { label: 'Inwards Policy Risk Fee', value: 110 },
        { label: 'Inwards Policy Risk Tax', value: 111 },
        { label: 'Inwards Policy Coinsurance Service Fee', value: 191 },
        { label: 'Inwards Policy Coinsurance Service Fee GST', value: 192 },
        { label: 'Inwards Policy Tabarru 1', value: 201 },
        { label: 'Inwards Policy Tabarru 2', value: 202 },
        { label: 'Inwards Policy Commission 2', value: 301 },
        { label: 'Inwards Policy Commission 2 GST', value: 302 },
        { label: 'Inwards Policy Commission 3', value: 401 },
        { label: 'Inwards Policy Commission 3 GST', value: 402 },
        { label: 'Outward Facultative Reinsurance Premium', value: 501 },
        { label: 'Outward Facultative Reinsurance Commission 1 & 2', value: 502 },
        { label: 'Outward Facultative Reinsurance Cession Stamp', value: 504 },
        { label: 'Outward Facultative Reinsurance RI Levy', value: 505 },
        { label: 'Outward Facultative Reinsurance Premium GST', value: 506 },
        { label: 'Outward Facultative Reinsurance Commission GST', value: 507 },
        { label: 'Outward Coinsurance Premium', value: 601 },
        { label: 'Outward Coinsurance Commission 1 & 2', value: 602 },
        { label: 'Outward Coinsurance Cession Stamp', value: 604 },
        { label: 'Outward Coinsurance RI Levy', value: 605 },
        { label: 'Outward Coinsurance Premium GST', value: 606 },
        { label: 'Outward Coinsurance Commission GST', value: 607 },
        { label: 'Outward Coinsurance Service Fee', value: 691 },
        { label: 'Outward Coinsurance Service Fee GST', value: 692 },
        { label: 'Outward Treaty Reinsurance Premium', value: 701 },
        { label: 'Outward Treaty Reinsurance Commission 1 & 2', value: 702 },
        { label: 'Outward Treaty Reinsurance Cession Stamp', value: 704 },
        { label: 'Outward Treaty Reinsurance RI Levy', value: 705 },
        { label: 'Outward Treaty Reinsurance Premium GST', value: 706 },
        { label: 'Outward Treaty Reinsurance Commission GST', value: 707 },
        { label: 'Inwards Claim Payment', value: 1001 },
        { label: 'Inwards Claim Payment Input GST', value: 1002 },
        { label: 'Inwards Claim Payment Output GST', value: 1003 },
        { label: 'Inwards Claim Payment Deemed Input GST', value: 1004 },
        { label: 'Outward Claim Facultative Reinsurance Recovery', value: 1501 },
        { label: 'Outward Claim Coinsurance Recovery', value: 1601 },
        { label: 'UPR', value: 2000 },
        { label: 'UPR Gross Premium', value: 2001 },
        { label: 'UPR Gross Commission', value: 2002 },
        { label: 'UPR Facultative Reinsurance Premium', value: 2011 },
        { label: 'UPR Facultative Reinsurance Commission', value: 2012 },
        { label: 'UPR Treaty Reinsurance Premium', value: 2021 },
        { label: 'UPR Treaty Reinsurance Commission', value: 2022 },
        { label: 'UPR Control', value: 2100 },
        { label: 'UPR Control Gross Premium', value: 2101 },
        { label: 'UPR Control Gross Commission', value: 2102 },
        { label: 'UPR Control Facultative Reinsurance Premium', value: 2111 },
        { label: 'UPR Control Facultative Reinsurance Commission', value: 2112 },
        { label: 'UPR Control Treaty Reinsurance Premium', value: 2121 },
        { label: 'UPR Control Treaty Commission', value: 2122 },
        { label: 'Unreleased UPR', value: 3000 },
        { label: 'Unreleased UPR Control', value: 3100 },
        { label: 'Claim Reserve', value: 4000 },
        { label: 'Claim Reserve Control', value: 4100 },
        { label: 'Claim Reserve Facultative Reinsurance', value: 4200 },
        { label: 'Claim Reserve Control Facultative Reinsurance', value: 4300 },
        { label: 'Claim Reserve Treaty Reinsurance', value: 4400 },
        { label: 'Claim Reserve Control Treaty Reinsurance', value: 4500 },
        { label: 'Debtors Control', value: 5001 },
        { label: 'Difference in Exchange - Revalued(Provision)', value: 5002 },
        { label: 'Difference in Exchange Realised', value: 5003 },
        { label: 'Write-off Small Balances', value: 5004 },
        { label: 'Bank Account', value: 5101 },
        { label: 'Bank Charges', value: 5102 },
        { label: 'Debtors Entry (Income/Expense/Asset/Liability', value: 6001 },
        { label: 'Debtors Entry Input GST', value: 6002 },
        { label: 'Debtors Entry Output GST', value: 6003 }
      ]
    }
  },
  methods: {
    doClearFilters() {
      this.resetValidator()
      this.defaultFilter = {}
      var thisPage = this
      var actionName = this.accountsTransForm.actionName
      // this.actions = ['Review', 'Matched', 'Query', 'Void']
      // Iterate through each object field, key is name of the object field
      Object.keys(this.accountsTransForm).forEach(function(key, index) {
        if (actionName === 'ACCT_MASTER_FILTER') {
          if (key === 'transactions') {
            thisPage.accountsTransForm[key] = 'Accounts'
          } else if (key === 'actions') {
            thisPage.accountsTransForm[key] = 'Review'
          } else if (key === 'actionName') {
            thisPage.accountsTransForm[key] = actionName
          } else {
            thisPage.accountsTransForm[key] = ''
          }
        } else if (actionName === 'GL_TRANS_FILTER') {
          if (key === 'transactions') {
            thisPage.accountsTransForm[key] = ''
          } else if (key === 'actions') {
            thisPage.accountsTransForm[key] = 'Both'
          } else if (key === 'actionName') {
            thisPage.accountsTransForm[key] = actionName
          } else {
            thisPage.accountsTransForm[key] = ''
          }
        } else if (actionName === 'MCH_DET_FILTER' || actionName === 'COMM_FILTER') {
          if (key === 'transactions') {
            thisPage.accountsTransForm[key] = ''
          } else if (key === 'actions') {
            thisPage.accountsTransForm[key] = ''
          } else if (key === 'actionName') {
            thisPage.accountsTransForm[key] = actionName
          } else {
            thisPage.accountsTransForm[key] = ''
          }
        } else if (actionName === 'NON_TRADE_FILTER') { // OS-899
          if (key === 'transactions') {
            thisPage.accountsTransForm[key] = 'Accounts'
          } else if (key === 'actions') {
            thisPage.accountsTransForm[key] = 'Review'
          } else if (key === 'actionName') {
            thisPage.accountsTransForm[key] = actionName
          } else if (key === 'includeBalance') {
            thisPage.accountsTransForm[key] = true
          } else if (key === 'includeVoidTransactions') {
            thisPage.accountsTransForm[key] = false
          } else {
            thisPage.accountsTransForm[key] = ''
          }
        }
      })
      this.performSearch()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('accountsTransFilterForm').then(result => {
        if (result) {
          // Reset to page 1
          this.paginationAM.page = 1
          this.paginationGL.page = 1
          this.paginationMD.page = 1
          this.paginationCM.page = 1
          this.accountsTransForm.applyFilters = 'Yes'
          this.performSearch()
        }
      })
    }
  },
  watch: {
    // 'paginationAcctNo': function (value) {
    //   this.fetchAcctNoData()
    // },
    // 'paginationDocNo': function (value) {
    //   this.fetchDocNoData(this.paginationDocNoSuppl.transaction,
    //     this.paginationDocNoSuppl.action,
    //     this.paginationDocNoSuppl.callerPage)
    // },
    // 'paginationFund': function (value) {
    //   this.fetchFundData()
    // },
    // 'paginationPolicy': function (value) {
    //   this.fetchPolicyData()
    // },
    // 'paginationAcctSuf': function (value) {
    //   this.fetchAcctSufData()
    // },
    'paginationShowPayersCheque': function (value) {
      this.fetchShowPayersChequeData()
    },
    'paginationGLTran': function (value) {
      this.getGLList()
    },
    'paginationMatch': function (value) {
      this.getMatchList()
    },
    'paginationRIMatch': function (value) {
      this.getRIMatchList()
    },
    'paginationCommPV': function (value) {
      this.getCommPVList()
    },
    'paginationBillAcctNo': function (value) {
      this.fetchBillAcctNoData()
    },
    'paginationGlAcctNo': function (value) {
      this.fetchGlAcctNoData()
    },
    'paginationAddrTo': function (value) {
      this.fetchAddrToData()
    },
    'paginationOvrdAcctNo': function (value) {
      this.fetchOvrdAcctNoData()
    }
    // 'paginationCurrency': function (value) {
    //   this.fetchCurrecyData()
    // },
    // 'paginationPayersChequeNo': function (value) {
    //   this.fetchPayersChequeNoData()
    // }
  }
}
